import { uploadToS3 } from 'lane-shared/helpers';
import {
  AttachmentResponse,
  AttachmentEntityInput,
  AttachmentDataForUpload,
} from 'lane-shared/types/attachment';

import { createAttachment } from './createAttachment';

export const uploadAttachment = async (
  entity: AttachmentEntityInput,
  attachmentAndThumbnail: AttachmentDataForUpload,
  options?: { parallelUploads?: boolean }
): Promise<AttachmentResponse> => {
  const createdAttachment = await createAttachment({
    entity,
    ...attachmentAndThumbnail,
  });

  const hasThumbnail =
    attachmentAndThumbnail.thumbnail && attachmentAndThumbnail.thumbnailBlob;

  if (options?.parallelUploads) {
    const uploads = [
      uploadToS3({
        signed: createdAttachment.fileSignedUrl,
        file: attachmentAndThumbnail.attachmentBlob,
        contentType: attachmentAndThumbnail.attachment.type,
      }),
    ];

    if (hasThumbnail) {
      uploads.push(
        uploadToS3({
          signed: createdAttachment.thumbnailSignedUrl,
          file: attachmentAndThumbnail.thumbnailBlob,
          contentType: attachmentAndThumbnail.thumbnailBlob!.type,
        })
      );
    }

    await Promise.all(uploads);
  } else {
    await uploadToS3({
      signed: createdAttachment.fileSignedUrl,
      file: attachmentAndThumbnail.attachmentBlob,
      contentType: attachmentAndThumbnail.attachment.type,
    });

    if (hasThumbnail) {
      await uploadToS3({
        signed: createdAttachment.thumbnailSignedUrl,
        file: attachmentAndThumbnail.thumbnailBlob,
        contentType: attachmentAndThumbnail.thumbnailBlob!.type,
      });
    }
  }

  return createdAttachment;
};
